import Vue from "vue";
import Vuelidate from "vuelidate";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);
Vue.use(Vuelidate);

export default new Vuetify({});
